var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsOtherBg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82746 6.22052L4.77268 7.77582C3.32368 9.71663 3.09337 12.3088 4.1775 14.4747C5.26162 16.6405 7.47473 18.0096 9.89678 18.0128C12.3194 18.0101 14.5332 16.6408 15.6174 14.4743C16.0232 13.6635 16.2448 12.793 16.2872 11.9194M5.82746 6.22052L8.61575 2.64051C8.91816 2.2373 9.39276 2 9.89678 2C10.4008 2 10.8754 2.2373 11.1778 2.64051L15.0209 7.77422C15.9282 8.98871 16.3581 10.4585 16.2872 11.9194M5.82746",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsOtherBg);
export default ForwardRef;